export default __webpack_public_path__ + "static/follow-rabbit-da417706729e6d8063d88fc028b2fca3.png";